import PrebuiltBetClassicImpl from './prebuilt-bet-classic.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import EventCardsTypes from 'modules/event-cards/types.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetClassic view that renders prebuilt bet card with the classic layout.
 *
 * @class PrebuiltBetClassic
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltBetClassic prop types.
 *
 * @property {node} [children] - Child components.
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {boolean} [showMarketName = true] - If true, then market name per part will be shown.
 * @property {string} [class] - Class name.
 * @property {string} [imgUrl] - Optional card background image.
 * @property {Mojito.Modules.EventCards.types.COLOR_MODES} [colorMode] - Card presentation mode.
 * @property {object} icons - Icons map.
 *
 * @memberof Mojito.Modules.PrebuiltBetClassic
 */
const propTypes = {
    children: PropTypes.node,
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
    showMarketName: PropTypes.bool,
    class: PropTypes.string,
    imgUrl: PropTypes.string,
    colorMode: PropTypes.oneOf(Object.values(EventCardsTypes.COLOR_MODES)),
    icons: PropTypes.object,
};

const defaultProps = {
    showMarketName: true,
    class: '',
};

export default UIView('PrebuiltBetClassic', PrebuiltBetClassicImpl, propTypes, defaultProps);
